import { render, staticRenderFns } from "./CollagePage.vue?vue&type=template&id=1aee32ea&scoped=true"
import script from "./CollagePage.vue?vue&type=script&lang=js"
export * from "./CollagePage.vue?vue&type=script&lang=js"
import style0 from "./CollagePage.vue?vue&type=style&index=0&id=1aee32ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee32ea",
  null
  
)

export default component.exports